import { parsePhoneNumber } from 'libphonenumber-js';
import { ValidatorConstraintInterface, ValidatorConstraint } from 'class-validator';

import { E164RegEx } from './phoneNumberE164Validator';

@ValidatorConstraint({ name: 'PhoneNumberE164OrGoTemplateIsValid' })
export default class PhoneNumberE164OrGoTemplateIsValid implements ValidatorConstraintInterface {
  validate(currentValue: string) {
    const isValid = /{{(.*)}}/g.test(currentValue);
    if (isValid) {
      return true;
    }

    try {
      const phone = parsePhoneNumber(currentValue);
      return phone ? phone.isValid() && E164RegEx.test(currentValue) : false;
    } catch (_) {
      return false;
    }
  }

  defaultMessage() {
    return 'The phone number is not valid';
  }
}
